import { useEffect, useState } from 'react';

/**
 * @param {number} innerWidth desired min width to establish the viewport
 * @returns Boolean
 */
function useIsMobile(innerWidth = 768) {
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    const isIPadPro = /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 0;
    const isSmallScreen = isIPadPro || window.innerWidth <= innerWidth;
    const isUserAgentMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    setIsMobile(isUserAgentMobileOrTablet || isSmallScreen);
  };

  useEffect(() => {
    handleResize(); // call only once at the beginning
    let timer;

    // throttledHandleResize will delay the execution of handleResize by 200 ms after
    // the resize event is triggered - will eliminate the unnecessary re-renders until the
    // resizing is settled.

    const throttledHandleResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => handleResize(), 200);
    };
    window.addEventListener('resize', throttledHandleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', throttledHandleResize);
    };
  }, []);

  return { isMobile };
}

export default useIsMobile;
